/* sugar:assets/hotspots.js@2.2.0 */
/*
  Hotspots (sections/hotspots.liquid).

  A marker on the picture and the row with the same number are one spot. Clicking either opens
  that row and lights both numbers; clicking an open spot's marker or row closes it. With "Open
  one spot at a time" on, opening a spot closes the others. The server draws the load state
  (first spot open or none), so nothing moves when the script attaches. Selecting a Spot block
  in the theme editor opens it.
*/
(function () {
  'use strict';
  if (window.customElements.get('sugar-hotspots')) return;

  class SugarHotspots extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onSelect = this.onSelect.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onSelect);
    }

    rows() {
      return this.querySelectorAll('.sugar-hotspots__row');
    }

    markers() {
      return this.querySelectorAll('.sugar-hotspots__marker');
    }

    // Writes only: every row and marker gets its state from one list of open indexes.
    apply(open) {
      Array.prototype.forEach.call(this.rows(), function (row, i) {
        var on = open.indexOf(i) !== -1;
        if (row.classList.contains('is-open') === on) return;
        row.classList.toggle('is-open', on);
        var toggle = row.querySelector('.sugar-hotspots__toggle');
        var panel = row.querySelector('.sugar-hotspots__panel');
        if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (panel) panel.inert = !on;
      });
      Array.prototype.forEach.call(this.markers(), function (marker, i) {
        var on = open.indexOf(i) !== -1;
        if (marker.classList.contains('is-active') === on) return;
        marker.classList.toggle('is-active', on);
        marker.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    openList() {
      var open = [];
      Array.prototype.forEach.call(this.rows(), function (row, i) {
        if (row.classList.contains('is-open')) open.push(i);
      });
      return open;
    }

    toggle(index, forceOpen) {
      var open = this.openList();
      var wasOpen = open.indexOf(index) !== -1;
      if (wasOpen && !forceOpen) {
        open.splice(open.indexOf(index), 1);
      } else if (!wasOpen) {
        if (this.dataset.one === 'true') open = [];
        open.push(index);
      }
      this.apply(open);
    }

    onClick(event) {
      var hit = event.target.closest('.sugar-hotspots__marker, .sugar-hotspots__toggle');
      if (!hit || !this.contains(hit)) return;
      var host = hit.classList.contains('sugar-hotspots__marker') ? hit : hit.closest('.sugar-hotspots__row');
      var index = parseInt(host && host.dataset.spot, 10);
      if (isNaN(index)) return;
      this.toggle(index, false);
    }

    onSelect(event) {
      if (!this.contains(event.target)) return;
      var row = event.target.closest('.sugar-hotspots__row');
      if (!row) return;
      var index = parseInt(row.dataset.spot, 10);
      if (!isNaN(index)) this.toggle(index, true);
    }
  }

  window.customElements.define('sugar-hotspots', SugarHotspots);
})();
